import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GlobalVariables } from '../data/global-variables';
import { Study } from '../data/study';
import { AlertService } from './alert.service';
import { Company, ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class StudiesService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private globalVariables: GlobalVariables,
    private alertService: AlertService
  ) { }

  getStudiesByToken(studyToken: string): Promise<Study[]> {
    return new Promise<Study[]>((resolve, reject) => {
      if (!environment.demo) {
        this.configService.BOOK_URL.then(confURL => {
          const url = `${confURL}/bookAccess/getStudiesByToken?token=${studyToken}`;
          this.http.get<Study[]>(url, { withCredentials: true, responseType: 'json' }).subscribe(res => {
            resolve(Study.sanitizeAll(res));
          })
        }, error => reject(error))
      } else {
        resolve([Study.getExample(this.configService.company)])
      }
    });
  };

  downloadStudies(studyUIDs: string[]): Observable<HttpEvent<Blob> | null> {
    if (!environment.demo) {
      const url = `${this.configService.syncBOOK_URL}/bookAccess/getStudies`;
      return this.http.post(url, studyUIDs, { withCredentials: true, responseType: 'blob', reportProgress: true, observe: 'events' });
    } else {
      const subject = new Subject<HttpEvent<Blob> | null>();
      setTimeout(() => {
        subject.next(null);
        subject.complete();
      }, 25);
      return subject.asObservable();
    }
  }

  downloadReport(studyUIDs: string[]) {
    // console.log('studyUIDs', studyUIDs);

    if (!environment.demo) {
      const url = `${this.configService.syncBOOK_URL}/bookAccess/getReportBytesByStudyUID`;
      this.http.post(url, studyUIDs, { withCredentials: true, responseType: 'arraybuffer' }).subscribe(reportBytes => {
        // console.log('reportBytes', reportBytes);
        if (reportBytes == null || reportBytes.byteLength == 0) {
          this.alertService.alert('Este estudio no dispone de informe. Póngase en contacto con el centro para más información')
        } else {
          const blob = new Blob([reportBytes], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);

          // if (this.globalVariables.isPageSmall)
          //   window.open(blobUrl);
          // else {
          //   // this.printBlob(blobUrl);
          //   this.downloadBlob(blobUrl);
          // }
          this.downloadBlob(blobUrl);

        }
      }, error => this.alertService.alert('No se ha podido descargar el informe. Por favor, actualice la página e inténtelo de nuevo más tarde'))
    } else {
      const url = 'assets/demo/report.pdf';
      // this.printBlob(url);
      this.downloadBlob(url);
    }
  }

  // window.open("data:application/pdf," + encodeURI(pdfString));

  printBlob(blobUrl: string) {
    let iframe = document.createElement('iframe'); //load content in an iframe to print later
    document.body.appendChild(iframe);

    iframe.style.display = 'none';
    iframe.src = blobUrl;
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus();
        iframe.contentWindow?.print();
      }, 1);
    };
  }

  downloadBlob(blobUrl: string) {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = blobUrl;
    a.download = 'informe.pdf';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(blobUrl);
  }

  askForStudy(studyUID: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (!environment.demo) {
        this.configService.BOOK_URL.then(BOOK_URL => {
          const url = BOOK_URL + '/bookAccess/askForStudy?studyUID=' + studyUID;
          this.http.get<void>(url, { withCredentials: true, responseType: 'json' }).subscribe(res => {
            resolve();
          }, error => {
            reject(error);
          })
        });
      } else {
        resolve();
      }
    })
  }

  checkStudyStatus(studyUID: string): Observable<boolean> {
    return new Observable<boolean>(observer => {
      if (!environment.demo) {
        this.configService.BOOK_URL.then(BOOK_URL => {
          const url = BOOK_URL + '/bookAccess/checkStudyStatus?studyUID=' + studyUID;
          this.http.get<boolean>(url, { withCredentials: true, responseType: 'json' }).subscribe(res => {
            observer.next(res);
            observer.complete();
          }, error => {
            observer.error(error);
            observer.complete();
          })
        });
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }


}
